module.exports = __webpack_public_path__ + "static/img/1.f8e43b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/1.png
// module id = 1o3G
// module chunks = 0